import { createStore } from 'vuex'

export default createStore({
  state: {
      active:"/home/about",
      quickMenu:[
        {
          component: "/home/about",
          icon_class: "fa fa-check-square-o",
          name: "首页",
        }
      ],
  },
  getters: {
  },
  mutations: {
    /**
     * 重载数据
     * @param state
     */
    onStoreLoad( state ) {
      var oldQuick = JSON.parse(window.localStorage.getItem("quickMenu"))
      var active = window.localStorage.getItem("active")
      if(oldQuick && active){
        state.quickMenu = oldQuick;
        state.active = active ? active : "/home/about";
      }else{
        state.active = "/home/about";
      }
    },
    /**
     * 选择标签
     * @param state
     * @param row
     */
    changeMenu(state, row){
      if (row.component === '/home/about') {
        return true;
      }
      let result = state.quickMenu.findIndex(item => item.name === row.name)
      //如果等于-1说明 quickMenu 不存在那么就插入数组中，否则什么都不做
      if (result === -1){
        //console.log(result)
        if (state.quickMenu.length >= 6){
          state.quickMenu.splice(1, 1);
        }
        state.quickMenu.push(row);
        window.localStorage.setItem('quickMenu',JSON.stringify(state.quickMenu))
      }
      //console.log(state.quickMenu.length)
    },
    /**
     * 关闭标签
     * @param state
     * @param val
     */
    closeMenu(state, val) {
      if (val.component === '/home/about') {
        return true;
      }
      let index = state.quickMenu.findIndex(item => item.name === val.name);
      if (val.component === state.active){
        state.active = state.quickMenu[index-1].component;
      }
      state.quickMenu.splice(index, 1);
      window.localStorage.setItem('active',state.active)
      window.localStorage.setItem('quickMenu',JSON.stringify(state.quickMenu))
    },
    /**
     * 选中菜单
     * @param state
     * @param e  选中地址
     */
    bindActive(state,e){
      state.active = e;
      window.localStorage.setItem("active",e)
    }
  },
  actions: {
  },
  modules: {
  }
})
